import { type HTMLAttributes } from 'react';
import cx from 'classnames';

export type BadgeTone = 'neutral' | 'primary' | 'info' | 'warning' | 'danger' | 'success';

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  /** The role of the status, never its colour: `danger` is a failure, `primary` an accent like «Новое». */
  tone?: BadgeTone;
}

const toneClasses: Record<BadgeTone, string> = {
  neutral: 'bg-surface-muted text-ink-muted',
  primary: 'bg-primary text-white',
  info: 'bg-info-surface text-info',
  warning: 'bg-warning-surface text-warning',
  danger: 'bg-danger-surface text-danger',
  success: 'bg-success-surface text-success',
};

/** A short status label. Spacing goes in `className`; colour comes from `tone`. */
export function Badge({ tone = 'neutral', className, ...props }: BadgeProps) {
  return (
    <span
      className={cx(
        'inline-flex items-center justify-center rounded-full px-3 py-1 text-ui-xs-strong',
        toneClasses[tone],
        className,
      )}
      {...props}
    />
  );
}
